import { Subject } from 'rxjs';
import { selectIcon } from '../components/UI/selector';

const subject = new Subject();
const percentSubject = new Subject();
const toasterSubject = new Subject();
const activitySubject = new Subject();
const gymIDSubject = new Subject();
const modalSubject = new Subject();
const stopWorkoutSubject = new Subject();
const stopActivitySubject = new Subject();
const addRoomSubject = new Subject();
const logOutSubject = new Subject();
const downloadSubject = new Subject();
const toolTipSubject = new Subject();

export const modalPopup = {
    cross: true,
    reWrite: true,
    color: '#F22B5D',
    outside: false
}

export const dropdownStatus = {
    showOptionList: false,
    id: null
}

const roomData = {
    detail: {},
    sendData: data => roomData.detail = { ...data }
};

const logOut = {
    status: false,
    setLogOut: data => logOut.status = data
};

const userData = {
    detail: {},
    selectedGym: {},
    sendData: data => userData.detail = { ...data }
};

const announcemenData = {
    detail: {},
    selectedGym: {},
    sendData: data => announcemenData.detail = { ...data }
};


const showPassword = {
    status: false,
    changeStatus: data => showPassword.status = data,
    getStatus: () => showPassword.status
};

const messageService = {
    ongoing: false,
    show: true,
    count: [],
    sendMessage: async (message) => {
        if (message) {
            await messageService.count.push(message);
        } else {
            await messageService.count.pop();
        }
        subject.next({ show: messageService.count.length > 0 })
    },
    getMessage: () => subject.asObservable(),
    sendPercentMessage: message => percentSubject.next({ percent: message.percent, text: message.text }),
    getPercentMessage: () => percentSubject.asObservable()
}

export const activityService = {
    sendActivityMessage: message => activitySubject.next(message),
    getActivityMessage: () => activitySubject.asObservable()
}

export const downloadService = {
    sendDownload: message => downloadSubject.next(message),
    getDownload: () => downloadSubject.asObservable()
}

export const toolTipService = {
    sendToolTip: message => toolTipSubject.next(message),
    getToolTip: () => toolTipSubject.asObservable()
}

const toasterSubscriber = {
    sendToasterData: data => toasterSubject.next({ data: data }),
    getToasterData: () => toasterSubject.asObservable()
}

const stopWorkoutService = {
    sendStopMessage: message => stopWorkoutSubject.next({ data: message }),
    getStopMessage: () => stopWorkoutSubject.asObservable()
}

const stopActivityService = {
    sendStopMessage: message => stopActivitySubject.next({ data: message }),
    getStopMessage: () => stopActivitySubject.asObservable()
}

const addRoomService = {
    sendStopMessage: message => addRoomSubject.next({ data: message }),
    getStopMessage: () => addRoomSubject.asObservable()
}

const logOutService = {
    sendStopMessage: message => logOutSubject.next({ data: message }),
    getStopMessage: () => logOutSubject.asObservable(),
    sendMessage: message => logOutSubject.next({ data: message }),
    getMessage: () => logOutSubject.asObservable()
}

const gymIDService = {
    gymID: {
        id: '',
        name: '',
        code: '',
        coachId: ''
    },
    sendGymID: data => {
        gymIDService.gymID = { ...data };
        return gymIDSubject.next({ gymID: data })
    },
    getGymID: () => gymIDSubject.asObservable()
}

export const streamId = {
    detail: '',
    sendData: data => streamId.detail = data
};

export const modalService = {
    sendModalMessage: message => modalSubject.next(message),
    getModalMessage: () => modalSubject.asObservable(),
}

const pattern = {
    memberShip: '^[a-zA-Z0-9]{8}',
    // memberShip: '^[a-zA-Z]{4}[0-9]{4}',
    // eslint-disable-next-line
    email: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
    username: /^\w+[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
    // eslint-disable-next-line
    // username: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
    streamUrl: /^(http[s]?.*?\.m3u8$)/,
}

const imageError = (event) => {
    event.target.onerror = null;
    event.target.src = selectIcon('userDummy');
}

const imageErrors = (status, event) => {
    event.target.onerror = null;
    event.target.src = selectIcon(status);
}

export {
    logOut,
    messageService,
    gymIDService,
    showPassword,
    toasterSubscriber,
    stopActivityService,
    addRoomService,
    userData,
    roomData,
    pattern,
    imageError,
    imageErrors,
    stopWorkoutService,
    logOutService
};